// Single source of truth for marketing CTA copy. Change a string here and
// every button, trust line and promise on the site updates with it.

export const CAL_URL =
  "https://cal.com/scaler-technologies-fy5v7q/on-boarding-call-prep-pos?overlayCalendar=true";

export const CTA = {
  PRIMARY: "Start my free 30-day trial",
  PRIMARY_SHORT: "Try free for 30 days",
  SECONDARY_HUMAN: "Book a 15-minute setup call",
  TERTIARY: "See a sample dashboard",
  TRUST_LINE: "Free for 30 days · No contracts · Cancel in two clicks",
  TRUST_LINE_FULL:
    "Nothing charged for 30 days · No contracts · No setup fees · Cancel anytime",
  PROMISE_HEADLINE: "See the value in 30 days, or don't pay.",
  PROMISE_DETAIL:
    "If PREP isn't saving you time and money by day 30, cancel in two clicks and you're never charged.",
} as const;

// Plan-card badges. "Most popular" is a claim we can't yet back with customer
// counts, so it lives here as a one-line change if it needs to be softened
// (e.g. "Recommended for delis & cafés").
export const PLAN_BADGES = {
  essentials: "Books, stock & payroll",
  performance: "Most popular",
  power: "Best value",
} as const;

export const PLAN_BEST_FOR = {
  essentials: "Best for owners who want clean books, stock under control and payroll sorted.",
  performance:
    "Best for delis, cafés and restaurants that want to know which dishes, prices and channels make money.",
  power:
    "Best for owners ready to grow: everything above, plus customers, loyalty, reviews and online presence.",
} as const;

// Hand-updated. null hides the counter and shows "Limited to our first 50
// stores" only, so we never display a made-up countdown.
export const FOUNDING_SPOTS_LEFT: number | null = null;

export const FOUR_FEARS = [
  {
    q: "Will I get charged by surprise?",
    a: "No. Nothing is charged for 30 days. Cancel any time before day 30 in two clicks and you pay nothing.",
  },
  {
    q: "Am I locked in?",
    a: "No. No contracts, no hardware, no setup fees. Cancel in two clicks from Settings.",
  },
  {
    q: "Will setup eat my week?",
    a: "No. Connect Clover or Square in minutes, or we'll do it with you on a 15-minute call.",
  },
  {
    q: "What if it's not worth it?",
    a: "Then you don't pay. If PREP isn't saving you time and money by day 30, cancel and you're never charged.",
  },
] as const;

/** Trial signup link, tagged with where the click came from. */
export const trialHref = (src: string, extra: Record<string, string> = {}) => {
  const params = new URLSearchParams({ src, ...extra });
  return `/register?${params.toString()}`;
};
